import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const MeetingPreparationSectionMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: {
      variant: 'h2',
      weight: 'medium',
      color: 'textPrimary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: {
      variant: 'h6',
      weight: 'medium',
      color: 'primaryGray',
      align: 'center',
    },
  }, overrideReadOnly);

export default MeetingPreparationSectionMetaOverrideSet;
